module.exports = __webpack_public_path__ + "f7388ea1da18b09eb1f7f9a51bbf4a8f.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/perks/houses/sir-hoots-a-lots-castle.png
// module id = 2866
// module chunks = 0